module.exports = __webpack_public_path__ + "img/2.b1e18a73.jpg";